var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitations-card",class:{'hide': !_vm.getProcessingError},attrs:{"id":"invitations"}},[_c('div',{staticClass:"card bg-danger"},[_c('div',{staticClass:"card-body"},[_vm._v(" "+_vm._s(_vm.getProcessingError)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }